import { useMemo } from 'react';
import helpFilesUtility from '@/utils/helpFiles';
import { AdvisorGroupSetting } from '@/store/settingsApi';
import AdvisorGroupSettings from '@/utils/advisorGroupSettings.utility';

const useGenerateLinks = ({
  advisorGroupSettings,
  currentRole,
}: {
  advisorGroupSettings: AdvisorGroupSetting[] | undefined;
  currentRole: string;
}) => {
  // TODO: Currently returning false since we don't have a contact modal.
  const shouldRenderContactSupport = useMemo(() => {
    // const shouldRenderContactSupport = AdvisorGroupSettings(
    //   advisorGroupSettings,
    // ).getByKey("InvestorShowContactSupport");

    return false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advisorGroupSettings]);

  const shouldRenderSecurityLink = useMemo(() => {
    return AdvisorGroupSettings(advisorGroupSettings).getByKey(
      'InvestorInfoSecurityLink',
    );
  }, [advisorGroupSettings]);

  const securityLink = useMemo(() => {
    if (!advisorGroupSettings) {
      return;
    }

    return helpFilesUtility.buildUrl({
      pathName: 'Security',
      advisorGroupSettings,
      currentRole,
    });
  }, [advisorGroupSettings, currentRole]);

  return {
    shouldRenderContactSupport,
    shouldRenderSecurityLink,
    securityLink,
  };
};

export default useGenerateLinks;
